import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MagnifyingGlass } from 'components/CommonIcons';
import * as styles from './Searchbar.scss';

/**
 * @class Searchbar
 * @classdesc Reusable Searchbar Component
 * @property {Object} state
 */
export default class Searchbar extends Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  };

  static defaultProps = {
    className: null,
    disabled: false,
    iconClassName: null,
    inputClassName: null,
    placeholder: 'Search',
    size: 'SMALL',
    style: null,
  };

  constructor(props) {
    super(props);
    const { value } = this.props;
    this.state = {
      search: value,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ search: nextProps.value });
  }

  changeHandler = ({ target: { value } }) => {
    const { onChange } = this.props;

    this.setState({ search: value });
    return onChange(value);
  };

  render() {
    const { className, disabled, iconClassName, inputClassName, placeholder, size, style } = this.props;
    const { search } = this.state;
    const large = size === 'LARGE';

    return (
      <div className={classNames(styles.searchbar, { [styles.searchbarLarge]: large }, className)}>
        <span className={classNames(styles.searchIcon, iconClassName)}><MagnifyingGlass /></span>
        <input
          className={classNames(
            styles.searchField,
            inputClassName,
            { [styles.searchFieldLarge]: large },
            { [styles.searchFieldDisabled]: disabled },
          )}
          onChange={this.changeHandler}
          placeholder={placeholder}
          style={style}
          value={search}
          disabled={disabled}
        />
      </div>
    );
  }
}
